<template>
	<transition name="fade">
		<div class="library__sidebar">
	      	<vue-custom-scrollbar  class="scroll-area library__sidebar__subject">
	            <div class="library__sidebar__subject__wrap" v-if="dataSubject">
	                <b-card no-body v-for="(item, index) in dataSubject" class="card-item border-0 secondary-color-txt" :key="index"  :class="{'active':true}">
	                    <div class="card-wrap display-block">
	                      	<b-card-header 
		                      	header-tag="header" 
		                      	role="tab" 
	                      		class="border-0 border-rd-8 display-flex-center secondary-color-txt font-size-16"
		                      	@click="openCollapse(`cat_${item.subjectId}`, item)" 
		                      	:class="{'active primary-color font-sanpro-semibold': collapseOpen === `cat_${item.subjectId}` || item.subjectId === subjectIdActive}" 
	                      	>
		                        <div class="cat-head display-flex justify-content-md-between full-width" >
		                            <span class="margin-0 font-size-16">
		                                {{ item.name }}
		                            </span>
		                        </div>
						
	                      	</b-card-header>
	                      	<b-collapse 
	                      		v-if="item && item.bookGroups && item.bookGroups.length > 0" 
	                      		:id="`cat_${item.subjectId}`" 
	                      		accordion="my-accordion" 
	                      		role="tabpanel" 
	                      		:visible="collapseOpen === `cat_${item.subjectId}`"
	                      	>
		                        <b-card-body class="p-0">
		                        	<ul class="cat-child margin-0">
		                        		<li class="d-block" v-for="(child, pos) of item.bookGroups" :class="{'active': parseInt(groupActive) === child.bookGroupId}">
		                        			<a href="javascript:;" class="font-sanpro primary-color-txt font-size-16 display-flex justify-content-between full-width" @click="viewLibByGroup(`cat_child_${item.subjectId}_${child.bookGroupId}`, child)">
		                        				<span>
		                        					{{ child.name }} 
		                        				</span>
		                        			</a>
		                        			<b-collapse v-if="child && child.books && child.books.length > 0" :visible="collapseChildOpen === `cat_child_${item.subjectId}_${child.bookGroupId}`">
		                        				<b-card-body class="p-0">
				                        			<ul class="cat-child margin-0" >
						                        		<li class="d-block" v-for="(book, loc) of child.books" :class="{'active': parseInt(bookActicve) === book.bookId}">
						                        			<a href="javascript:;" class="font-sanpro primary-color-txt font-size-16 display-flex justify-content-between full-width"  @click="viewLibByBook(child.bookGroupId, book)">
						                        				<span>
						                        					{{ book.name }} 
						                        				</span>
						                        			</a>
						                        		</li>
						                        	</ul>
						                        </b-card-body>
						                    </b-collapse>
		                        		</li>
		                        	</ul>
		                        </b-card-body>
	                      	</b-collapse>
	                      	<b-collapse 
	                      		v-if="item && item.books && item.books.length > 0" 
	                      		:id="`cat_${item.subjectId}`" 
	                      		accordion="my-accordion" 
	                      		role="tabpanel" 
	                      		:visible="collapseOpen === `cat_${item.subjectId}`"
	                      	>
		                        <b-card-body class="p-0">
		                        	<ul class="cat-child margin-0">
		                        		<li class="d-block" v-for="(child, pos) of item.books" :class="{'active': parseInt(bookActicve) === child.bookId}">
		                        			<a href="javascript:;" class="font-sanpro primary-color-txt font-size-16 display-flex justify-content-between full-width"  @click="viewLibByBook(child.bookGroupId, child)">
		                        				<span>
		                        					{{ child.name }} 
		                        				</span>
		                        			</a>
		                        		</li>
		                        	</ul>
		                        </b-card-body>
	                      	</b-collapse>
	                    </div>
	                </b-card>
	            </div>
	        </vue-custom-scrollbar>
			<ActiceCodeContent />
		</div>
	</transition>
</template>

<script>
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	import { STORE_KEY } from './../../_store/constants'
	import { mapState, mapActions } from 'vuex'

	export default {
		name: 'Sidebar',
		props: {
			dataSubject: Array
		},
		components: {
			vueCustomScrollbar,
			ActiceCodeContent: () => import('./ActiceCodeContent.vue')
		},
		data () {
			return {
				subjectIdActive: 0,
				tabActive: 0,
				groupActive: 0,
				indexSubject:0,
				bookActicve: 0,
				collapseOpen: '',
				collapseChildOpen: '',
			    settingsViewBookSidebar: {
                    maxScrollbarLength: 300
                },
			}
		},
		computed: {
			...mapState(STORE_KEY, ['paramSearchLessons']),
			routerQuery() {
				return this.$router.history.current.query;
			}
		},
		watch: {
			'dataSubject': 'initSidebar'
		},
		mounted() {
			this.initSidebar()
		},
		methods: {
			...mapActions(STORE_KEY, ['setParamSearchLesson']),

			initSidebar() {
				if(this.routerQuery.mon) {
					let indexSubject = this.dataSubject.findIndex(subj => subj.subjectId === parseInt(this.routerQuery.mon) );
					if(indexSubject > -1) {
						let idCollapse = `cat_${this.dataSubject[indexSubject].subjectId}`;
						this.subjectIdActive = this.dataSubject[indexSubject].subjectId;
						this.collapseOpen = idCollapse;
						this.groupActive = this.routerQuery.nhom;
						// Await render DOM
						// setTimeout(() => {
						// 	this.$root.$emit('bv::toggle::collapse', idCollapse);
						// }, 200);

						if(this.routerQuery.sach) {
							this.bookActicve = 	this.routerQuery.sach;
							this.collapseChildOpen = `cat_child_${this.dataSubject[indexSubject].subjectId}_${this.routerQuery.nhom}`	
						}
					}
				}

			},

			openCollapse(id, cat, typeGroup = false) {
                if((cat.bookGroups && cat.bookGroups.length > 0) || (cat.books && cat.books.length > 0)) {
                  	this.collapseOpen = this.collapseOpen === id ? '' : id;
                  	this.collapseChildOpen = '';
                  	this.groupActive = 0;
                  	// this.$root.$emit('bv::toggle::collapse', id)
                } 
                // else if(cat.books && cat.books.length > 0 && this.collapseOpen) {
                // 	this.collapseChildOpen = this.collapseChildOpen === id ? '' : id;
                // 	this.bookActicve = cat.bookid;
                // 	// this.$root.$emit('bv::toggle::collapse', id)
                // } 
                else {
                	this.collapseOpen = '';
                }
                // const routerQuery = this.$router.history.current.query;
                // if(typeGroup) {
                // 	this.groupActive = cat.bookGroupId;
                // 	this.setParamSearchLesson({...this.paramSearchLessons, bookGroupId: cat.bookGroupId});
                // 	this.$router.replace({query: {lop: this.paramSearchLessons.classId, mon: this.subjectIdActive, nhom: cat.bookGroupId, sach: 0}});
                // } else {
                	this.subjectIdActive = cat.subjectId;
                	this.setParamSearchLesson({...this.paramSearchLessons, subjectId: cat.subjectId, bookId: 0, bookGroupId: 0});
                	this.$router.replace({query: {lop: this.paramSearchLessons.classId, mon:  cat.subjectId, nhom: 0, sach: 0}});
                // }
            },

            viewLibByGroup(id, cat) {
            	this.collapseChildOpen = this.collapseChildOpen === id ? '' : id;
                this.bookActicve = cat.bookid;
                this.groupActive = cat.bookGroupId;
            	this.setParamSearchLesson({...this.paramSearchLessons, bookGroupId: cat.bookGroupId, bookId: 0});
            	this.$router.replace({query: {lop: this.paramSearchLessons.classId, mon: this.subjectIdActive, nhom: cat.bookGroupId, sach: 0}});
            },

            viewLibByBook(group, book) {
            	this.bookActicve = book.bookId;
            	this.setParamSearchLesson({...this.paramSearchLessons, bookId: book.bookId});
            	this.$router.replace({query: {lop: this.paramSearchLessons.classId, mon: this.subjectIdActive, nhom: group, sach: book.bookId}});
            }
		}
	}
</script>

<style lang="scss" scoped>
	@import "./../../../../assets/scss/_variables";
	@import "./../../../../assets/scss/_mixins";
	@import "./../../../../assets/scss/general";

	.library__sidebar {
		.card {
			background: transparent;

			header {
				min-height: 36px;
				padding: 5px 18px;
				margin-bottom: 2px;
				@extend .bg-transparent;
				cursor: pointer;

				&.active, &:hover {
					background: $btn_hover_color;
					@extend .primary-color;
				}
			}

			&-body {
				ul {
					padding: 8px 0 0;
					li {
						padding: 5px 18px 5px 30px;

						&.active {
							>a {
								@extend .primary-color;
							}
						}
					}
				}
			}
		}

		&__subject {
			margin-bottom: 30px;
		}
	}
</style>